import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../components/main/index.vue';
// import { getUser } from '@/utils/auth';
import homeRoutes from './home';
import adminRoutes from './admin';
import store from '../store'

import VXETable from 'vxe-table';
const $XModal = VXETable.modal;

Vue.use(VueRouter);

// const routes = [
//   {
//     path: '/redirect',
//     component: Main,
//     children: [
//       {
//         path: '/redirect/:path(.*)',
//         component: resolve => require(['@/views/redirect'], resolve),
//       },
//     ],
//   },
//   {
//     path: '/login',
//     name: 'Login',
//     component: resolve => require(['@/views/login/index.vue'], resolve),
//   },
//   {
//     path: '/admin/editPager/:id/:pagerId',
//     name: 'EditPager',
//     component: resolve => require(['@/admin/editPager/index.vue'], resolve),
//   },
//   {
//     path: '/examPager/:id/:type',
//     name: 'ExamPager',
//     component: resolve => require(['@/views/pager/exam.vue'], resolve),
//   },
//   ...homeRoutes,
//   ...adminRoutes,
// ];

// const router = new VueRouter({
//   mode: 'history',
//   routes,
//   scrollBehavior() {
//     return { x: 0, y: 0 };
//   },
// });

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Main,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: resolve => require(['@/views/redirect'], resolve),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: resolve => require(['@/views/login/index.vue'], resolve),
  },

  {
    path: '/examPager/:id/:type',
    name: 'ExamPager',
    component: resolve => require(['@/views/pager/exam.vue'], resolve),
  },
  ...homeRoutes,
]


/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  ...adminRoutes
]

const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
  console.log('重置路由')
}

// router.beforeEach((to, from, next) => {
//   if (to.path == '/user' && getUser() == null) {
//     next('/login');
//   }if (to.name == 'Video' && getUser() == null) {
//     $XModal.alert({ content: '未登录，不能观看视频！', title: '提示' }).then(type => {
//       if (type == 'confirm') {
//         next('/login');
//       }
//     });
//   }
//   next();
// })

// const whiteList = ['/login', '/redirect/', '/'] // no redirect whitelist
const whiteList = ['/redirect/', '/']
router.beforeEach(async (to, from, next) => {
  console.log('to:', to);
  console.log('from:', from);
  console.log('next:', next);
  let user = store.getters.getUserInfo;
  if (whiteList.indexOf(to.path) !== -1) {
    // in the free login whitelist, go directly
    next()
  } else {
    if (user == null) {
      // console.log('user==null && not whiteList')
      if (to.path == '/user') {
        // next('/login');
        $XModal.alert({ content: '未登录，不能查看个人中心！', title: '提示' }).then(type => {
          if (type == 'confirm') {
            // next('/login');
            next('/')
          }
        });
      }
      if (to.name == 'Video') {
        $XModal.alert({ content: '未登录，不能观看视频！', title: '提示' }).then(type => {
          if (type == 'confirm') {
            // next('/login');
            next('/')
          }
        });
      }
      next()
    } else {
      let hasRoute = store.state.permission.hasRoute
      if (hasRoute || user.roles.length == 0) {
        next()
        // console.log('hasRoute:',hasRoute)
      } else {
        let roleCode = [user.roles[0].code]
        // console.log('用户不为空，用户角色为:', roleCode)
        // generate accessible routes map based on roles
        const accessRoutes = await store.dispatch('permission/generateRoutes', roleCode)
        // console.log('可访问路由为：', accessRoutes[0].children)
        // dynamically add accessible routes
        // router.addRoutes(accessRoutes)

        for (let i = 0, length = accessRoutes.length; i < length; i += 1) {
          const element = accessRoutes[i];
          router.addRoute(element)
        }
        // 根据路由生成菜单数据并存入permission/menuData中
        let menuData = []
        accessRoutes[0].children.forEach(route => {
          const menuItem = {
            label: route.meta.title,
            icon: route.meta.icon,
            path: route.path == '/' ? '/admin' : '/admin/' + route.path,
            hidden: route.hidden
          };
          menuData.push(menuItem);
        });
        store.commit('permission/SET_MENU_DATA', menuData);
        store.commit('permission/SET_HAS_ROUTE', true);
        next({ ...to, replace: true })
      }
    }
  }
})

export default router
